import { CellAction } from "./cell-action";

import { ProjectsType } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";

export const columns: ColumnDef<ProjectsType>[] = [
  {
    accessorKey: "title",
    header: "NOM DU TRAVAUX",
  },
  {
    accessorKey: "description",
    header: "DESCRIPTION",
    cell: ({ row }) => {
      const message = row.original.description;
      return message.length > 10 ? `${message.slice(0, 10)}...` : message;
    },
  },
  {
    accessorKey: "date_debut",
    header: "DATE DEBUT",
    cell: ({ row }) => {
      return showDate(row.original.date_debut);
    },
  },
  {
    accessorKey: "date_fin",
    header: "DATE FIN",
    cell: ({ row }) => {
      return showDate(row.original.date_fin);
    },
  },
  // {
  //   accessorKey: "status",
  //   header: "STATUS",

  //   cell: ({ row }) => {
  //     return (
  //       <Badge
  //         className={`${
  //           row.original.status === "Terminé"
  //             ? "bg-green-500"
  //             : row.original.status === "En attente"
  //             ? "bg-yellow-500"
  //             : row.original.status === "En cours"
  //             ? "bg-orange-500"
  //             : ""
  //         }  w-1/2 `}
  //       >
  //         {row.original.status}
  //       </Badge>
  //     );
  //   },
  // },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
